
import React from 'react';
import Layout from '@/components/Layout';
import { useList } from '@/contexts/ListContext';
import ContentCard from '@/components/ContentCard';
import { Info } from 'lucide-react';
import ProtectedRoute from '@/components/auth/ProtectedRoute';

const MyList = () => {
  const { myList } = useList();

  return (
    <Layout>
      <ProtectedRoute>
        <div className="pt-16 pb-20 px-4 md:px-6">
          <h1 className="text-2xl font-bold text-white mb-6 font-gt-super">My List</h1>
          
          {myList.length > 0 ? (
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
              {myList.map((content) => (
                <ContentCard 
                  key={content.id} 
                  content={content}
                />
              ))}
            </div>
          ) : (
            <div className="flex flex-col items-center justify-center py-12 text-center">
              <div className="bg-secondary p-4 rounded-full mb-4">
                <Info size={32} className="text-muted-foreground" />
              </div>
              <h3 className="text-xl font-medium text-white mb-2">Your list is empty</h3>
              <p className="text-muted-foreground max-w-md">
                Add shows and movies to your list so you can easily find them later.
              </p>
            </div>
          )}
        </div>
      </ProtectedRoute>
    </Layout>
  );
};

export default MyList;
